// NOTE: Referral codes are intentionally non-sensitive — they're public marketing
// codes designed to be shared in URLs (e.g. ?ref=XYZ123). localStorage is appropriate.
// They unlock a $25 discount but cannot be used to authenticate or access PII.
import api from "./api";

const KEY = "if_referral_code";

export function getStoredReferral() {
  try {
    return localStorage.getItem(KEY) || "";
  } catch (e) {
    console.warn("Referral read failed:", e);
    return "";
  }
}

export function setStoredReferral(code) {
  try {
    if (code) localStorage.setItem(KEY, code.toUpperCase());
    else localStorage.removeItem(KEY);
  } catch (e) {
    console.warn("Referral write failed:", e);
  }
}

export function clearStoredReferral() {
  try { localStorage.removeItem(KEY); } catch (e) { console.warn("Referral clear failed:", e); }
}

/**
 * Capture ?ref=XYZ from the current URL, validate it, and persist it.
 * Returns {code, referrer_first_name, discount_usd} or null.
 */
export async function captureReferralFromUrl() {
  const params = new URLSearchParams(window.location.search);
  const code = params.get("ref");
  if (!code) return null;
  try {
    const { data } = await api.get(`/referrals/lookup/${code.toUpperCase()}`);
    setStoredReferral(data.code);
    return data;
  } catch {
    return null;
  }
}

/** Look up a stored code's metadata (referrer name, discount). */
export async function lookupStoredReferral() {
  const code = getStoredReferral();
  if (!code) return null;
  try {
    const { data } = await api.get(`/referrals/lookup/${code}`);
    return data;
  } catch {
    clearStoredReferral();
    return null;
  }
}
